import React from "react";
import { Button, Drawer, notification, Popconfirm } from "antd";
import { Label, Input } from "reactstrap";
import { Form, Row, Col } from "antd";
import { WarningTwoTone, CloseOutlined } from "@ant-design/icons";

import "./styles.css";

export default class EditableTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      childrenDrawerQuiz: false,
      errors: {},
      question: "",
      options: [],
      points: "",
      correct: "",
      currentOptionAdded: "",
    };
  }

  notActiveNotification = () => {
    let placement = "bottomRight";
    const key = `open${Date.now()}`;
    notification.open({
      duration: 5,
      message: "Attention Champion!",
      description: (
        <div id="loading">
          <h3>This feature is under development.</h3>
          <p>Please visit again later, Thanks.</p>
        </div>
      ),
      placement,
      icon: <WarningTwoTone twoToneColor="#BF2F2F" />,
      key,
    });
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });

    if (e.target.name === "correct") {
      this.setState({
        [e.target.name]: e.target.value - 1,
      });
    } else {
      this.setState({ [e.target.name]: e.target.value });
    }
  };

  resetForm = () => {
    this.setState({
      errors: {},
      question: "",
      options: [],
      points: "",
      correct: "",
      currentOptionAdded: "",
    });
  };

  saveQuiz = () => {
    this.props.onSubmit(this.state);
    this.onChildrenDrawerQuizClose();
    this.resetForm();
  };

  showChildrenDrawerQuiz = () => {
    this.setState({
      childrenDrawerQuiz: true,
    });
  };

  onChildrenDrawerQuizClose = () => {
    this.setState({
      childrenDrawerQuiz: false,
    });
  };

  saveMcqOption = () => {
    const temp = this.state.options;
    temp.push(this.state.currentOptionAdded);
    this.setState({
      options: temp,
      currentOptionAdded: "",
    });
    // console.log(this.state);
  };

  deleteOption = (index) => {
    this.state.options.splice(index, 1);
    this.setState({ options: this.state.options });
    // console.log(this.state.quiz);
  };

  render() {
    const { errors } = this.state;
    return (
      <div>
        <Button
          className="mButton"
          onClick={() => {
            this.showChildrenDrawerQuiz();
          }}
        >
          Add Quiz
        </Button>
        <Drawer
          width={620}
          visible={this.state.childrenDrawerQuiz}
          title="Add New Quiz"
          onClose={this.onChildrenDrawerQuizClose}
          footer={[
            <Button
              className="mButton"
              key="submit"
              type="primary"
              onClick={this.saveQuiz}
            >
              Submit
            </Button>,
          ]}
        >
          <Form id="topicForm" layout="vertical" hideRequiredMark>
            <Row gutter={24}>
              <Col span={24}>
                <Form.Item label="Question">
                  <Input
                    id="question"
                    name="question"
                    onChange={this.onChange}
                    value={this.state.question}
                    placeholder="Enter Question"
                  />
                  <Label className="red">{errors.question}</Label>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={24}>
              <Col span={24}>
                <Form.Item label="MCQ Options">
                  <Input
                    id="currentOptionAdded"
                    name="currentOptionAdded"
                    onChange={this.onChange}
                    value={this.state.currentOptionAdded}
                    placeholder="Enter Mcq Option"
                  />
                  <Button type="primary" onClick={this.saveMcqOption}>
                    Submit
                  </Button>
                  <Label className="red">{errors.options}</Label>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={24}>
              <Col span={24}>
                <Form.Item label={"Quiz Options: " + this.state.options.length}>
                  <div className="scrollableDiv2 tc">
                    {this.state.options.map((item, key) => {
                      return (
                        <Row>
                          <h6 className="topicTab">{key + 1 + " | " + item}</h6>
                          <Popconfirm
                            placement="right"
                            title="Remove Option ？"
                            okText="Yes"
                            cancelText="No"
                            onConfirm={() => {
                              this.deleteOption(key);
                            }}
                          >
                            <CloseOutlined
                              type="Delete MCQ"
                              title="Delete MCQ"
                              style={{ fontSize: "23px", color: "red" }}
                              theme="outlined"
                            />
                          </Popconfirm>
                        </Row>
                      );
                    })}
                  </div>
                  <Label className="red">{errors.courseTopics}</Label>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={24}>
              <Col span={12}>
                <Form.Item label="Points">
                  <Input
                    id="points"
                    name="points"
                    type="number"
                    onChange={this.onChange}
                    value={this.state.points}
                    placeholder={
                      this.state.options.length === 0
                        ? "Enter Options First"
                        : "Enter Mcq Points"
                    }
                    disabled={this.state.options.length === 0 ? true : false}
                  />
                  <Label className="red">{errors.points}</Label>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Correct Option">
                  <Input
                    id="correct"
                    name="correct"
                    type="number"
                    onChange={this.onChange}
                    value={
                      this.state.options.length === 0
                        ? this.state.correct
                        : this.state.correct + 1
                    }
                    disabled={this.state.options.length === 0 ? true : false}
                    placeholder={
                      this.state.options.length === 0
                        ? "Enter Options First"
                        : "Enter Correct Option number"
                    }
                  />
                  <Label className="red">{errors.correct}</Label>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Drawer>
      </div>
    );
  }
}
